<template>
  <div
    :dir="direction"
    :class="{ 'visible opacity-100 pointer-events-auto': showBanner, 'invisible opacity-0 pointer-events-none': !showBanner }"
    class="c-cookie-overlay"
  >
    <div ref="popup" class="c-cookie-banner theme theme-white">
      <IconCookie class="mx-auto mb-2.5" />

      <h2 v-if="headline" class="text-2xl font-bold mb-2.5">
        {{ headline }}
      </h2>

      <p class="text-sm mb-4">
        {{ content }}
      </p>

      <a
        v-if="link && linkText"
        :href="link"
        :target="openInNewWindow ? '_blank' : '_self'"
        class="inline-block text-sm underline hover:no-underline mb-6"
      >
        {{ linkText }}
      </a>

      <button class="btn solid w-full justify-center" @click="onAcceptCookies">
        {{ btnText }}
      </button>
    </div>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import IconCookie from '@/assets/icons/cookie.svg'
import tracking from '@/helpers/tracking'

export default {
  components: {
    IconCookie
  },
  props: {
    headline: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      required: true
    },
    linkText: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    btnText: {
      type: String,
      required: true
    },
    openInNewWindow: {
      type: Boolean,
      required: true
    },
    direction: {
      type: String,
      default: 'ltr'
    }
  },
  data() {
    return {
      showBanner: false
    }
  },
  mounted() {
    if (localStorage.getItem('accepted-cookie-policy') !== 'accepted') {
      this.showBanner = true
      this.$nextTick(() => {
        disableBodyScroll(this.$refs.popup)
      })
    }
  },
  beforeDestroy() {
    if (this.showBanner) {
      enableBodyScroll(this.$refs.popup)
    }
  },
  methods: {
    onAcceptCookies() {
      localStorage.setItem('accepted-cookie-policy', 'accepted')
      tracking.cookieAccept()
      enableBodyScroll(this.$refs.popup)
      this.showBanner = false
    }
  }
}
</script>
